import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'MONITORING_SERVICES',
    itemActionName: 'MONITORING_SERVICE',
});
